<div class="close" (click)="close()">{{ 'NGX-MESSAGING.close' | translate }}</div>
<h1 mat-dialog-title class="mat-dialog-container__title">
  {{ 'NGX-MESSAGING.profileSettings' | translate | uppercase }}
</h1>
<ng-container>
  <form [formGroup]="userForm">
    <div class="modal-content" mat-dialog-content>
      <div class="modal-content__avatar">
        <messaging-avatar
          [name]="$safeNavigationMigration(currentUserSesion()?.subjectMessageableEntity?.displayName)"
          [initialsSize]="2"
          size="150"
          [src]="profileImageURL()"
          (click)="changePhoto()">
        </messaging-avatar>
        <input #imgProfileUpload type="file" accept="image/*" (change)="onChange($event)" hidden />
      </div>
      <span (click)="changePhoto()" class="modal-content__change">Change photo</span>
      <mat-form-field appearance="fill" class="full-width-input">
        <input
          type="text"
          formControlName="displayName"
          matInput
          placeholder="{{ 'NGX-MESSAGING.displayName' | translate }}" />
      </mat-form-field>
    </div>
    <div class="modal-actions" mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="save()">
        {{ 'NGX-MESSAGING.Save' | translate }}
      </button>
    </div>
  </form>
</ng-container>
